import { Text, Flex } from '_shared/designSystem/components';
import PropTypes from 'prop-types';
import { ClickableHandedness } from '_shared/components/ClickableHandedness';

export default function PlayerDetails(props) {
  const { name, handedness, playerId, onHandednessUpdate, disabled = false } = props;
  return (
    <Flex alignItems="center">
      <Flex gap={1}>
        <Text fontSize="sm" color="grey.800">
          {name}{' '}
          <ClickableHandedness
            handedness={handedness}
            playerName={name}
            playerId={playerId}
            onHandednessUpdate={onHandednessUpdate}
            disabled={disabled}
          />
        </Text>
      </Flex>
    </Flex>
  );
}

PlayerDetails.propTypes = {
  name: PropTypes.string,
  handedness: PropTypes.string,
  playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onHandednessUpdate: PropTypes.func,
  disabled: PropTypes.bool
};
